import { Navigate, useLocation, useParams } from 'react-router-dom'

export default function LegacyRenderRedirect() {
	const location = useLocation()
	const params = useParams()

	const nextPath = `/assets/clothes/${params.collection}/${params.gender}/${params.kind}/${params.slotId}/${params.drawableLocalIndex}/${params.meshPartIndex}/${params.assetId}`

	return <Navigate to={`${nextPath}${location.search}`} replace />
}
